import { ValidationError } from "@common/types";

export class ReportEditorData
{
    Id: string | null = null;
    Name: string | null = null;
    Description: string | null = null;
}

export class ReportEditorViewModel
{
    opened: boolean = false;
    isSaving: boolean = false;

    data: ReportEditorData | null = null;
    reportNameError: string | null = null;

    displayValidationErrors(errors: ValidationError[])
    {
        this.isSaving = false;

        for (const error of errors)
        {
            this.reportNameError = error.Error;
        }
    }

    clearValidationErrors()
    {
        this.reportNameError = null;
    }

    show(data: ReportEditorData)
    {
        this.data = data;

        this.opened = true;
    }

    close()
    {
        this.opened = false;
        this.isSaving = false;
    }
}